import { Signal, TemplateRef } from '@angular/core';
import { ColorUtility } from '../utilities/kanban.utilities';

export enum KanbanColumnType {
    Standard,
    Header
}

export enum KanbanEditorType {
    Internal = 'Internal',
    External = 'External'
}

export interface KanbanColumn {
    name: string;
    type?: KanbanColumnType;
    color?: string;
    key: string;
    items: any[];
    hasItems: boolean;
    collapsed?: boolean;
    data?: any;
}

export interface KanbanSwimlane {
    name: string;
    /** Stable lane identity from the source grouping; `name` is a label and may repeat or be renamed. */
    key?: string;
    data?: any;
    columns: KanbanColumn[];
    sortOrder?: number;
    collapsed?: boolean;
    alwaysShowSwimlaneHeader?: boolean;
}

export type KanbanDbClickParams<T = any> = {
    item: T;
    isSwimlaneItem?: boolean;
}

export interface KanbanHost {
    getItems(lane: KanbanSwimlane, columnKey: string): any[];
    hasItems(columnKey: string): boolean;
    laneColumnHasItems(lane: KanbanSwimlane, columnKey: string): boolean;
    columnItemCount(columnKey: string): number;
    /** `event` carries `detail`, which is how the second click of a double click is ignored. */
    onItemSelected(item: any, swimlane?: boolean, event?: MouseEvent): void;
    /** A gesture-driven selection. The directive has already resolved single from double, so there
     *  is no `detail` to guard on — this is only ever the first tap of a gesture. */
    onItemTapped(item: any, swimlane?: boolean): void;
    onItemDblClicked<T = any>(event: KanbanDbClickParams<T>);
    onColumnToggle(column: KanbanColumn);
    canCollapse(column: KanbanColumn);
    onLaneToggle(lane: KanbanSwimlane): void;
    canCollapseLane(lane: KanbanSwimlane): boolean;
    isSelected(item: any, selectedItem: any): boolean;
    /** Card identity for `@for`. Keyed so a card whose record was replaced keeps its DOM node. */
    trackItem(item: any, index: number): unknown;
    laneItemCount(lane: KanbanSwimlane): number;
    columnWidth: Signal<string>;
    colorUtility: ColorUtility;
    selectedItem: Signal<any>;
    showSwimlaneColumn: Signal<boolean>;
    itemTemplate: Signal<TemplateRef<any> | undefined>;
    swimlaneColumnTemplate: Signal<TemplateRef<any> | undefined>;
    swimlaneHeaderTemplate: Signal<TemplateRef<any> | undefined>;
    emptyMessage: Signal<string>;
    valueField: Signal<string>;
}
